import { useEffect, useState } from "react";
import React from "react";
import {
  Form,
  FormGroup,
  FormFeedback,
  Input,
  Button,
  Label,
  Row,
  Col,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import ReactDOM from "react-dom";
import { connect } from "react-redux";
import {
  CustomerState,
  actionCreators,
  CallState,
  PaymentState,
} from "../store/Customer";
import { ApplicationState } from "../store";
import "./CustomerLookup.css";
import { parse } from "qs";
import { validation } from "../utils/validation";
import _ from "lodash";
import moment from "moment";
import { PolicyPaymentItem } from "../store/Customer";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons";
import { faCheck } from "@fortawesome/free-solid-svg-icons";
import sage from "../images/sage.png";
import visa from "../images/visa.png";
import mastercard from "../images/mastercard.png";
import config from "../store/config";

export interface Payments {
  id: string;
  include: boolean;
  status: string;
  invoice: number | null;
  reference: string;
  suffix: number | null;
  amountToTake: number;
  transactionType: string | null;
  effectiveDate: Date | null;
  totalPremium: number | null;
  takenToDate: number | null;
  remainingToTake: number | null;
  adhoc?: boolean;
  adhocSuffix: number | null;
}

interface CustomerLookupActions {
  onPay(items: Payments[]): void;

  store(items: PolicyPaymentItem[]): void;
}

const formatter = new Intl.NumberFormat("en-GB", {
  style: "currency",
  currency: "GBP",
  minimumFractionDigits: 2,
});

type CustomerLookupProps = typeof actionCreators &
  React.Props<{}> &
  CustomerLookupActions & { customer: CustomerState };

export class CustomerLookup extends React.Component<CustomerLookupProps> {
  state = {
    urlParams: null,
    payByBacs: false,
    branch: 0,
    reference: "",
    displayFindError: false,
    display404: false,
    currentRef: "",
    finding: false,
    pressedLookupButton: false,
    autoSearch: false,
    payments: [],
    filteredIncludePayments: [],
    totalPayments: 0,
    showPaymentSubmissionLoading: false,
    showPaymentSubmissionSuccess: false,
    showPaymentSubmissionError: false,
    showSuccessPaymentModal: false,
    showFailedPaymentModal: false,
    email: "",
    obscureEmail: "",
    sendEmailFormValid: false,
    showEmailRequiredError: false,
    showEmailInvalidError: false,
    showObscureEmailRequiredError: false,
    showObscureEmailInvalidError: false,
    pressedYesPleaseButton: false,
    sendingEmail: false,
    sendReceiptSuccess: false,
    sendReceiptError: false,
    isCancelled: false,
    uppDetails: null,
    showDD: false,
    aprInfo: null,
    fetchedAprInfo: null,
    paymentMethod: null,
  };

  constructor(props: CustomerLookupProps) {
    super(props);
  }
  formRef = React.createRef<HTMLFormElement>();
  componentDidMount() {
    //---------------------------------------------
    //Get URL params

    this.state.urlParams = parse(document.location.search.replace(/\?/, ""));

    //Passing Branch and Customer Reference on URL
    if (this.state.urlParams.branch && this.state.urlParams.cust_ref) {
      let s: string = this.state.urlParams.cust_ref.toString();
      this.setState(
        {
          reference: s,
          branch: parseInt(this.state.urlParams.branch.toString()),
          autoSearch: true,
        },
        () => {
          if (
            this.state.reference !== "" &&
            this.state.reference.trim().length == 6 &&
            /^[a-z]{4}\d{2}$/i.test(this.state.reference) &&
            this.state.autoSearch
          ) {
            this.findCustomer();
          }
        },
      );
    }

    //Success/Failed Payments on URL
    if (this.state.urlParams.ref) {
      let branch = this.state.urlParams.ref.slice(5, 6);
      let reference = this.state.urlParams.ref.slice(7, 13);

      this.setState(
        {
          reference: reference,
          branch: +branch,
          autoSearch: true,
        },
        () => {
          this.findCustomer();

          let paymentFailed =
            this.state.urlParams.failed && this.state.urlParams.failed == "true"
              ? true
              : false;
          let cancelled =
            this.state.urlParams.reason &&
            this.state.urlParams.reason == "cancelled"
              ? true
              : false;
          if (!paymentFailed) {
            this.setState({ showSuccessPaymentModal: true });
          } else {
            this.setState({
              showFailedPaymentModal: true,
              isCancelled: cancelled,
            });
          }
        },
      );
    }

    window.scrollTo(0, 0);
  }

  componentWillReceiveProps(nextProps) {
    //Check customer has changed
    if (this.props.customer !== nextProps.customer) {
      //Stop lookup spinner
      if (nextProps.customer.haveCustomer) {
        //Setup payments
        if (this.props.customer.policies != nextProps.customer.policies) {
          const paymentsTemp = nextProps.customer.policies.map((p) => ({
            id: p.id || p.reference + p.suffix + p.totalPremium,
            include:
              !(p.status && p.status.toLowerCase() == "paid") ||
              (p.lergOverdue && p.lergOverdue == 1),
            status: p.status,
            invoice: p.invoice,
            adhoc: p.totalPremium === 0,
            amountToTake: p.amount === undefined ? p.remainingToTake : p.amount,
            effectiveDate: p.effectiveDate,
            totalPremium: p.totalPremium,
            takenToDate: p.takenToDate,
            remainingToTake: p.remainingToTake,
            reference: p.reference,
            suffix: p.suffix,
            transactionType: p.transactionType,
            adhocSuffix: null,
            lergOverdue: p.lergOverdue,
            offerFinance: p.offerFinance,
            parentPolicy: p.parentPolicy,
          }));

          let filteredIncludePayments = [];
          let total = 0;
          let hasDD = false;
          paymentsTemp.forEach((v) => {
            if (v.include) {
              filteredIncludePayments.push(v);
              total = total + (v.amountToTake || 0);
              if (v.offerFinance) {
                hasDD = true;
              }
            }
          });

          this.setState({
            payments: paymentsTemp.sort((a, b) =>
              a.parentPolicy > b.parentPolicy ? -1 : 1,
            ),
            filteredIncludePayments: filteredIncludePayments,
            totalPayments: total,
            showDD: hasDD,
            aprInfo: nextProps.customer.aprInfo,
            fetchedAprInfo: nextProps.customer.aprInfo, //copy used for tickbox restore!
          });
        }

        //Stop lookup spinner
        this.setState({
          finding: false,
          email:
            this.state.showSuccessPaymentModal &&
            nextProps.customer.email &&
            validation.isEmail(nextProps.customer.email)
              ? nextProps.customer.email
              : null,
          obscureEmail:
            this.state.showSuccessPaymentModal &&
            nextProps.customer.email &&
            validation.isEmail(nextProps.customer.email)
              ? this.obscureEmail(nextProps.customer.email)
              : null,
          sendEmailFormValid:
            this.state.showSuccessPaymentModal &&
            nextProps.customer.email &&
            validation.isEmail(nextProps.customer.email)
              ? true
              : false,
        });
      }

      //Check for errors
      if (nextProps.customer.error && !nextProps.customer.error404) {
        this.setState({
          displayFindError: true,
          finding: false,
        });
      } else if (nextProps.customer.error404) {
        this.setState({
          display404: true,
          finding: false,
        });
      } else {
        this.setState({
          displayFindError: false,
          display404: false,
        });
      }

      //Check for payments
      if (nextProps.customer.paymentState == PaymentState.FAILED) {
        this.setState({
          showPaymentSubmissionLoading: false,
          showPaymentSubmissionError: true,
        });
      }
      if (nextProps.customer.paymentState == PaymentState.SUCCESS) {
        //window.location.href = nextProps.customer.redirect;
        if (
          nextProps.customer.url &&
          nextProps.customer.url !== "" &&
          nextProps.customer.token &&
          nextProps.customer.token !== ""
        ) {
          this.setState(
            {
              uppDetails: {
                url: nextProps.customer.url,
                token: nextProps.customer.token,
              },
            },
            () => {
              if (this.formRef.current) {
                this.formRef.current.submit();
              }
            },
          );

          return;
        }
      }

      //Check for sending receipt
      if (
        this.props.customer.sendReceiptSuccess !==
        nextProps.customer.sendReceiptSuccess
      ) {
        this.setState(
          {
            sendReceiptSuccess: true,
            sendReceiptError: false,
            sendingEmail: false,
          },
          () => {
            setTimeout(() => {
              this.setState({ showSuccessPaymentModal: false });
            }, 3000);
          },
        );
      }
      if (
        this.props.customer.sendReceiptError !==
        nextProps.customer.sendReceiptError
      ) {
        this.setState(
          {
            sendReceiptError: true,
            sendReceiptSuccess: false,
            sendingEmail: false,
          },
          () => {
            setTimeout(() => {
              this.setState({ showSuccessPaymentModal: false });
            }, 3000);
          },
        );
      }
    }
  }

  pay = (directDebit: boolean = false, aprInfo: any = null) => {
    let items: PolicyPaymentItem[];

    items = this.state.filteredIncludePayments.map((p) => ({
      id: p.id,
      invoice: p.invoice,
      status: p.status,
      include: p.include,
      amount: p.amountToTake,
      effectiveDate: p.effectiveDate,
      totalPremium: p.totalPremium,
      takenToDate: p.takenToDate,
      remainingToTake: p.remainingToTake,
      reference: p.reference,
      suffix: p.suffix,
      transactionType: p.transactionType,
      adhoc: p.adhoc,
      adhocSuffix: p.adhocSuffix,
      lergOverdue: p.lergOverdue,
      offerFinance: p.offerFinance,
      parentPolicy: p.parentPolicy,
    }));

    this.props.pay(
      items,
      parseFloat(this.state.totalPayments.toFixed(2)),
      directDebit,
      aprInfo,
    );
    this.setState({
      showPaymentSubmissionLoading: true,
      showPaymentSubmissionError: false,
    });
  };

  findCustomer = () => {
    //console.log(`${this.state.reference} reference`);
    this.setState({
      displayFindError: false,
      finding: true,
      pressedLookupButton: true,
      currentRef: `${this.state.branch}/${this.state.reference}`,
      totalPayments: 0,
    });
    this.props.find(this.state.branch, this.state.reference);
  };

  cleanBranch = (branch: number) => {
    if (branch > 9 || branch.toString().length >= 2) return 9;
    return branch;
  };

  clean = (value: string) => {
    return value
      .toUpperCase()
      .replace(/[^A-Z0-9]/, "")
      .substring(0, 6);
  };

  managePayments = (payment) => {
    if (payment) {
      payment.include = !payment.include;

      let _payments = Object.assign([], this.state.payments);

      if (this.state.showDD && payment.parentPolicy) {
        _payments.forEach((p) => {
          p.include = payment.include;
        });
      }

      this.setState(
        { payments: _payments, filteredIncludePayments: [] },
        () => {
          //Filtering only payments with INCLUDE flag
          let total = 0;
          let filteredIncludePayments = [];
          for (let payment of this.state.payments) {
            if (payment.include) {
              filteredIncludePayments.push(payment);
              total = total + (payment.amountToTake || 0);
            }
          }

          if (total > 0) {
            this.setState({
              filteredIncludePayments: filteredIncludePayments,
              totalPayments: total,
              aprInfo: this.state.fetchedAprInfo,
            });
          } else {
            this.setState({
              filteredIncludePayments: filteredIncludePayments,
              totalPayments: 0,
              aprInfo: {
                monthlyAmount: 0,
                interestRate: 0,
                interestCharged: 0,
                rate: 0,
              },
            });
          }
        },
      );
    }
  };

  validateForm = (field) => {
    let isValid = true;

    this.setState({ sendEmailFormValid: true });

    //Email
    if (!field || field == "email") {
      this.setState({
        showEmailRequiredError: false,
        showEmailInvalidError: false,
      });
      if (this.state.email && validation.isEmpty(this.state.email)) {
        this.setState({
          showEmailRequiredError: true,
          sendEmailFormValid: false,
        });
        isValid = false;
      }
      if (
        this.state.email &&
        !validation.isEmpty(this.state.email) &&
        !validation.isEmail(this.state.email)
      ) {
        this.setState({
          showEmailInvalidError: true,
          sendEmailFormValid: false,
        });
        isValid = false;
      }
    }

    //Obscure Email
    if (field == "obscureEmail") {
      this.setState({
        showObscureEmailRequiredError: false,
        showObscureEmailInvalidError: false,
      });
      if (validation.isEmpty(this.state.obscureEmail)) {
        this.setState({
          showObscureEmailRequiredError: true,
          sendEmailFormValid: false,
        });
        isValid = false;
      }
      if (
        !validation.isEmpty(this.state.obscureEmail) &&
        !validation.isEmail(this.state.obscureEmail)
      ) {
        this.setState({
          showObscureEmailInvalidError: true,
          sendEmailFormValid: false,
        });
        isValid = false;
      }
    }

    return isValid;
  };

  sendEmail = () => {
    //Validate Form
    if (this.validateForm(null)) {
      if (this.props.customer.email) {
        this.state.email =
          this.state.obscureEmail.indexOf("*") > -1
            ? this.state.email
            : this.state.obscureEmail;
      } else {
        this.state.email = this.state.obscureEmail;
      }

      this.setState({
        pressedYesPleaseButton: true,
        sendEmailFormValid: true,
        sendingEmail: true,
      });
      this.props.sendReceipt(this.state.email, this.state.urlParams.ref);
    } else {
      this.setState({ pressedYesPleaseButton: true });
    }
  };

  obscureEmail(email) {
    let finalObscuredEmail = "";

    let firstLetterEmail = email.slice(0, 1);
    let fullEmail = email.split("@")[0];
    let emailToObscure = fullEmail.substring(1);
    let emailObscured = emailToObscure.replace(
      emailToObscure,
      Array(emailToObscure.length + 1).join("*"),
    );

    let emailProvider = email.split("@")[1];
    let firstLetterEmailProvider = emailProvider.slice(0, 1);
    let emailProviderToObscure = emailProvider.substring(1).split(".")[0];
    let emailProviderObscured = emailProviderToObscure.replace(
      emailProviderToObscure,
      Array(emailProviderToObscure.length + 1).join("*"),
    );

    let emailDomain = emailProvider.substring(emailProvider.indexOf("."));

    finalObscuredEmail =
      firstLetterEmail +
      emailObscured +
      "@" +
      firstLetterEmailProvider +
      emailProviderObscured +
      emailDomain;

    return finalObscuredEmail;
  }

  render() {
    return (
      <div>
        {/*Pay by lookup/card*/}
        {!this.state.payByBacs && (
          <Row>
            {/*Lookup And Payments*/}
            <Col xs={12} sm={12} md={6}>
              {/*Lookup Search*/}
              <div className="section bg-white">
                <Form>
                  {/* Search */}
                  <h4 className="text-abg">
                    <b>Access your statement</b>
                  </h4>

                  <p className="font-size-16-px text-abg mt-4">
                    Please enter your customer reference
                  </p>

                  {/*Lookup Inputs and Button*/}
                  <Row noGutters className="align-items-center">
                    {/* Lookup Branch Input */}
                    <Col xs={"auto"}>
                      <div className="d-flex align-items-center">
                        <Input
                          placeholder="0"
                          className="branch-input form-control"
                          min={0}
                          max={9}
                          value={this.state.branch}
                          type="number"
                          onKeyDown={(e) => {
                            const key = e.key;

                            if (key === "Backspace" || key === "Delete") {
                              return true;
                            }
                            if (/^[0-9]*$/.test(e.key)) {
                              return true;
                            }
                            e.preventDefault();
                            return false;
                          }}
                          onChange={(e) => {
                            this.setState(
                              {
                                branch: isNaN(parseInt(e.target.value))
                                  ? null
                                  : this.cleanBranch(parseInt(e.target.value)),
                              },
                              () => {
                                if (this.state.branch != null) {
                                  var referenceInput =
                                    document.getElementById("referenceInput");
                                  referenceInput.focus();
                                  referenceInput.click();
                                }
                              },
                            );
                          }}
                        />

                        <div className="mx-3">/</div>
                      </div>
                    </Col>

                    {/* Lookup Reference Input */}
                    <Col xs={"auto"}>
                      <Input
                        placeholder="WXYZ01"
                        id="referenceInput"
                        className="lookup-reference-input form-control"
                        onKeyDown={(e) => {
                          if (this.props.customer.haveCustomer) {
                            this.props.reset();
                          }
                          if (e.nativeEvent.keyCode === 13) {
                            this.findCustomer();
                          }
                        }}
                        value={this.state.reference}
                        autoFocus
                        type="text"
                        onChange={(e) => {
                          this.setState({
                            showCustomerDetailsForm: false,
                            reference: this.clean(e.target.value),
                            displayFindError: false,
                            display404: false,
                          });
                        }}
                      />
                    </Col>

                    {/* Lookup Button */}
                    <Col xs={4} sm={4} md={4} className="ps-3">
                      {!this.state.finding && (
                        <button
                          disabled={
                            !/^[a-z]{4}\d{2}$/i.test(this.state.reference) ||
                            this.state.branch == null ||
                            this.state.finding
                          }
                          className={
                            !/^[a-z]{4}\d{2}$/i.test(this.state.reference) ||
                            this.state.branch == null ||
                            this.state.finding
                              ? "btnLookup disabled"
                              : "btnLookup"
                          }
                          onClick={(_) => this.findCustomer()}
                        >
                          Lookup
                        </button>
                      )}
                      {this.state.finding && (
                        <Spinner
                          size="lg"
                          color="info"
                          className="d-block m-auto"
                        />
                      )}
                    </Col>
                  </Row>

                  {/* Search Result Messages */}
                  {this.state.displayFindError && !this.state.display404 && (
                    <div className="mt-4 text-danger">
                      Sorry, we are unable to find a match for this customer
                      reference.
                      <br />
                      Please re-enter, or if you are unable to find your
                      reference then please call us on{" "}
                      {!config.brand ||
                        ((config.brand && config.brand) == "abg" && (
                          <b>01603 218000</b>
                        ))}{" "}
                      {config.brand && config.brand == "stech" && (
                        <b>01223 324233</b>
                      )}{" "}
                      and we will be happy to help.
                    </div>
                  )}
                  {this.state.display404 && (
                    <div className="mt-4 text-danger">
                      Sorry, we are unable to find a match for this customer
                      reference.
                      <br />
                      Please re-enter, or if you are unable to find your
                      reference then please call us on{" "}
                      {!config.brand ||
                        ((config.brand && config.brand) == "abg" && (
                          <b>01603 218000</b>
                        ))}{" "}
                      {config.brand && config.brand == "stech" && (
                        <b>01223 324233</b>
                      )}{" "}
                      and we will be happy to help.
                    </div>
                  )}
                </Form>
              </div>

              {/*Payments List*/}
              {this.props.customer.haveCustomer && (
                <div>
                  {/*No Payments Message*/}
                  {this.state.payments.length == 0 && (
                    <h5 className="text-abg my-4">
                      You have no outstanding amounts to pay
                    </h5>
                  )}
                  {/*Payments*/}
                  {this.state.payments.length > 0 && (
                    <h4 className="text-abg">
                      <b>
                        {this.props.customer.name},{" "}
                        {this.props.customer.postCode}
                      </b>
                    </h4>
                  )}
                  {this.state.payments.length > 0 && (
                    <h5 className="text-abg mb-3">
                      Here's your statement with us
                    </h5>
                  )}
                  {this.state.payments.length > 0 &&
                    this.state.payments.map((p) => (
                      <div
                        className={
                          p.lergOverdue && p.lergOverdue == 1
                            ? "payment-item-container overdue"
                            : "payment-item-container"
                        }
                        key={p.id}
                      >
                        <div className="payment-item-section">
                          <div className="payment-item">
                            <div className="payment-item-title">
                              {p.transactionType}
                            </div>
                            {p.invoice && p.invoice > 0 && (
                              <React.Fragment>
                                <div className="text-muted right">
                                  Invoice #: {p.invoice}
                                </div>
                              </React.Fragment>
                            )}
                            <div className="text-muted">
                              Effective:{" "}
                              {p.effectiveDate &&
                                moment(p.effectiveDate)
                                  .toDate()
                                  .toLocaleDateString("en-GB")}
                            </div>
                          </div>
                          <div className="total-to-pay">
                            {(!p.status ||
                              (p.status && p.status.toLowerCase()) !=
                                "paid") && (
                              <React.Fragment>
                                <div className="d-flex align-items-center">
                                  {p.lergOverdue && p.lergOverdue == 1 ? (
                                    <input
                                      type="checkbox"
                                      checked={p.include}
                                      readOnly={true}
                                    />
                                  ) : (
                                    <input
                                      type="checkbox"
                                      checked={p.include}
                                      onChange={() => this.managePayments(p)}
                                      disabled={
                                        this.state.showDD && !p.parentPolicy
                                      }
                                    />
                                  )}
                                  <span className="ms-2 font-size-15-px">
                                    Pay this now
                                  </span>
                                </div>
                                <div className="font-size-16-px">
                                  {formatter.format(p.amountToTake)}
                                </div>
                                {/* <div>
                                  DEBUG Offer Finance - {p.offerFinance}
                                </div>
                                <div>
                                  DEBUG Parent Policy - {p.parentPolicy}
                                </div> */}
                              </React.Fragment>
                            )}
                            {p.status && p.status.toLowerCase() == "paid" && (
                              <React.Fragment>
                                <div className="text-success font-size-15-px">
                                  <FontAwesomeIcon icon={faCheck} /> Payment
                                  processing
                                </div>
                                <div className="text-muted font-size-16-px">
                                  {formatter.format(p.amountToTake)}
                                </div>
                              </React.Fragment>
                            )}
                          </div>
                        </div>
                      </div>
                    ))}
                  {this.state.payments.length > 0 && (
                    <p className="text-abg my-3">
                      The information displayed is limited to protect your
                      privacy. If there are items that you do not recognise then
                      please call us to discuss with one of our team.
                    </p>
                  )}
                  {this.state.payments.length > 0 && (
                    <p className="text-abg my-3">
                      It can take up to 24hrs for payments to appear on our
                      systems, so if you have recently paid for items by BACS or
                      over the phone then they may still be listed here.
                    </p>
                  )}
                </div>
              )}

              {/*Payment Success Modal*/}
              {this.state.showSuccessPaymentModal && (
                <Modal
                  isOpen={true}
                  toggle={() =>
                    this.setState({ showSuccessPaymentModal: false })
                  }
                >
                  <ModalBody className="text-center">
                    <FontAwesomeIcon
                      icon={faCheckCircle}
                      size="4x"
                      className="text-success"
                    />

                    <h4 className="text-abg">Success!</h4>

                    <p className="text-abg my-4">
                      Thank you, your payment was successful. Your statement has
                      been updated to reflect your recent payments.
                    </p>

                    <p className="text-abg my-4">
                      If you would like us to send you confirmation of payment
                      please enter your email address below.
                    </p>

                    <Form>
                      {/*Email address*/}
                      <FormGroup row className="mx-2 my-2">
                        <Label for="email"></Label>
                        <Input
                          className="payment-success-email-input"
                          type={"text"}
                          name={"email"}
                          value={this.state.obscureEmail}
                          onChange={(event: any) => {
                            this.setState(
                              {
                                obscureEmail: event.target.value,
                              },
                              () => this.validateForm("obscureEmail"),
                            );
                          }}
                          placeholder="Please enter your email address"
                          invalid={
                            this.state.pressedYesPleaseButton &&
                            (this.state.showObscureEmailRequiredError ||
                              this.state.showObscureEmailInvalidError)
                          }
                        />
                        {this.state.pressedYesPleaseButton &&
                          this.state.showObscureEmailRequiredError && (
                            <FormFeedback>Please enter email</FormFeedback>
                          )}
                        {this.state.pressedYesPleaseButton &&
                          this.state.showObscureEmailInvalidError && (
                            <FormFeedback>
                              Please enter a valid email address
                            </FormFeedback>
                          )}
                      </FormGroup>

                      <Row className="justify-content-center mt-4">
                        {!this.state.sendingEmail &&
                          !this.state.sendReceiptSuccess &&
                          !this.state.sendReceiptError && (
                            <React.Fragment>
                              <Col>
                                <React.Fragment>
                                  <Button
                                    type="button"
                                    className="noreceipt-button btn rounded-0"
                                    style={{ width: "100%" }}
                                    onClick={() =>
                                      this.setState({
                                        showSuccessPaymentModal: false,
                                      })
                                    }
                                  >
                                    No receipt required
                                  </Button>

                                  <Button
                                    className="receipt-button btn rounded-0"
                                    style={{ width: "100%" }}
                                    disabled={!this.state.sendEmailFormValid}
                                    onClick={() => this.sendEmail()}
                                  >
                                    Send
                                  </Button>
                                </React.Fragment>
                              </Col>
                            </React.Fragment>
                          )}
                        {!this.state.sendReceiptSuccess &&
                          !this.state.sendReceiptError &&
                          this.state.sendingEmail && (
                            <Col>
                              <Spinner
                                color="info"
                                className="d-block m-auto"
                              />
                            </Col>
                          )}
                      </Row>

                      {this.state.sendReceiptSuccess && (
                        <p className="text-abg my-2">
                          Receipt has been sent to you successfully.
                        </p>
                      )}
                      {!this.state.sendingEmail &&
                        this.state.sendReceiptError &&
                        !this.state.sendingEmail && (
                          <p className="text-danger mt-2">
                            Sending receipt email failed.
                          </p>
                        )}
                    </Form>

                    <p className="text-abg my-4">
                      Note: please don't bookmark this page.
                    </p>
                  </ModalBody>
                </Modal>
              )}

              {/*Payment Failed Modal*/}
              {this.state.showFailedPaymentModal && !this.state.isCancelled && (
                <Modal
                  size={"sm"}
                  isOpen={true}
                  toggle={() =>
                    this.setState({ showFailedPaymentModal: false })
                  }
                >
                  <ModalBody className="text-center">
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      size="4x"
                      className="text-danger"
                    />

                    <h4 className="text-abg">Failed!</h4>

                    <p className="text-abg my-4">
                      Unfortunately we haven't been able to take a payment from
                      you. If you would like to call us we can try to take a
                      payment over the phone, call us on 01603 218000.
                    </p>

                    <Button
                      style={{ height: "42px" }}
                      className="btn btn-abg rounded-0 py-2 px-5 d-block m-auto"
                      onClick={() =>
                        this.setState({ showFailedPaymentModal: false })
                      }
                    >
                      Ok
                    </Button>
                  </ModalBody>
                </Modal>
              )}

              {this.state.showFailedPaymentModal && this.state.isCancelled && (
                <Modal
                  size={"sm"}
                  isOpen={true}
                  toggle={() =>
                    this.setState({ showFailedPaymentModal: false })
                  }
                >
                  <ModalBody className="text-center">
                    <FontAwesomeIcon
                      icon={faTimesCircle}
                      size="4x"
                      className="text-danger"
                    />

                    <h4 className="text-abg">Payment cancelled</h4>

                    <p className="text-abg my-4">
                      Unfortunately we haven't been able to take a payment from
                      you. If you would like to call us we can try to take a
                      payment over the phone, call us on 01603 218000.
                    </p>

                    <Button
                      style={{ height: "42px" }}
                      className="btn btn-abg rounded-0 py-2 px-5 d-block m-auto"
                      onClick={() =>
                        this.setState({ showFailedPaymentModal: false })
                      }
                    >
                      Ok
                    </Button>
                  </ModalBody>
                </Modal>
              )}
            </Col>

            {/*Total Payment*/}
            {this.props.customer.haveCustomer && (
              <Col xs={12} sm={12} md={6}>
                {this.state.showDD && (
                  /*DD Payment*/
                  <div className="section text-center bg-abg-light-blue">
                    <div className="d-block">
                      <h4 className="text-abg">
                        <b>Pay Monthly</b>
                      </h4>
                      <p className="text-abg pt-2">12 monthly payments of</p>

                      <h3 className="text-abg pt-2">
                        <b>
                          {formatter.format(
                            this.state.aprInfo?.monthlyAmount || 0,
                          )}
                        </b>
                      </h3>

                      {!this.state.showPaymentSubmissionLoading && (
                        <Button
                          type="button"
                          className={
                            "pay-button btn px-5 py-2 rounded-0 ml-auto my-3 " +
                            (this.state.totalPayments > 0
                              ? "btn-success"
                              : "btn-secondary")
                          }
                          style={{ height: "42px" }}
                          onClick={() => this.pay(true, this.state.aprInfo)}
                          disabled={this.state.totalPayments <= 0}
                        >
                          Pay Now by Direct Debit
                        </Button>
                      )}

                      {!this.state.showPaymentSubmissionLoading &&
                        this.state.showPaymentSubmissionError && (
                          <div className="mb-3 text-danger">
                            Unfortunately we haven't been able to take a payment
                            from you. If you would like to call us we can try to
                            take a payment over the phone, call us on{" "}
                            <b>01603 218000</b>.
                          </div>
                        )}

                      {this.state.showPaymentSubmissionLoading && (
                        <div className="my-4">
                          <Spinner color="info" className="d-block m-auto" />
                        </div>
                      )}

                      <div className="mx-4 my-4 mb-2">
                        <Row>
                          <Col xs={8} sm={10} md={8}>
                            <p className="text-abg text-start">Total Premium</p>
                            <p className="text-abg text-start">
                              Interest ({this.state.aprInfo?.interestRate || 0}%
                              Fixed, {this.state.aprInfo?.apr || 0}% APR)
                              <br />
                              Total Amount Payable
                            </p>
                          </Col>
                          <Col xs={4} sm={2} md={4}>
                            <div
                              style={{ float: "right" }}
                              className="text-start"
                            >
                              <p className="text-abg">
                                {formatter.format(this.state.totalPayments)}
                              </p>
                              <p className="text-abg">
                                {formatter.format(
                                  this.state.aprInfo?.interestCharged || 0,
                                )}
                                <br />
                                {formatter.format(
                                  (this.state.totalPayments || 0) +
                                    (this.state.aprInfo.interestCharged || 0),
                                )}
                              </p>
                            </div>
                          </Col>
                        </Row>

                        <Row>
                          <Col xs={12} sm={12} md={12}>
                            <p className="smallprint mt-1">
                              &#10013;The first payment might be slightly more
                              to make up the balance to the Total Amount Payable
                            </p>
                          </Col>
                        </Row>
                      </div>

                      {/*Total Payment Is 0 or less message*/}
                      {this.state.payments.length > 0 &&
                        this.state.totalPayments < 0 && (
                          <p className="text-danger my-3">
                            When the total of your outstanding credits and
                            debits is &#163;0.00 or less, then please call us on
                            the number above to speak to one of our team about
                            reconciling your account.
                          </p>
                        )}
                    </div>
                  </div>
                )}
                {/*Card Payment*/}
                <div className="section text-center bg-abg-light-blue">
                  <div className="d-block">
                    <h4 className="text-abg">
                      <b>Pay Annually</b>
                    </h4>
                    <p className="text-abg pt-2">A single card payment of</p>

                    <h3 className="text-abg pt-2">
                      <b>{formatter.format(this.state.totalPayments)}</b>
                    </h3>

                    {!this.state.showPaymentSubmissionLoading && (
                      <Button
                        type="button"
                        className={
                          "pay-button btn px-5 py-2 rounded-0 ml-auto my-3 " +
                          (this.state.totalPayments > 0
                            ? "btn-success"
                            : "btn-secondary")
                        }
                        style={{ height: "42px" }}
                        onClick={() => this.pay()}
                        disabled={this.state.totalPayments <= 0}
                      >
                        Pay Now by Card
                      </Button>
                    )}

                    {!this.state.showPaymentSubmissionLoading &&
                      this.state.showPaymentSubmissionError && (
                        <div className="mb-3 text-danger">
                          Unfortunately we haven't been able to take a payment
                          from you. If you would like to call us we can try to
                          take a payment over the phone, call us on{" "}
                          <b>01603 218000</b>.
                        </div>
                      )}

                    {this.state.showPaymentSubmissionLoading && (
                      <div className="my-4">
                        <Spinner color="info" className="d-block m-auto" />
                      </div>
                    )}

                    {/*Total Payment Is 0 or less message*/}
                    {this.state.payments.length > 0 &&
                      this.state.totalPayments < 0 && (
                        <p className="text-danger my-3">
                          When the total of your outstanding credits and debits
                          is &#163;0.00 or less, then please call us on the
                          number above to speak to one of our team about
                          reconciling your account.
                        </p>
                      )}
                  </div>
                </div>
                <div className="text-center">
                  <a
                    href="javascript:;"
                    onClick={(event: any) => {
                      this.setState({ payByBacs: true });
                    }}
                  >
                    <u>Or, pay by BACS</u>
                  </a>
                </div>
              </Col>
            )}
          </Row>
        )}

        {/*Pay by BACS - ABG Version*/}
        {this.state.payByBacs &&
          (!config.brand || (config.brand && config.brand) == "abg") && (
            <div>
              <Row>
                <Col>
                  <h2 className="section_title mb-4">Pay by BACS</h2>

                  <p className="page-details-text my-4">
                    Please use the following bank details to make your payment.
                    Enter your reference&nbsp;
                    {this.state.currentRef.substring(2, 8)}&nbsp;on your payment
                    to help us allocate it.
                  </p>

                  <div className="my-5">
                    <p className="page-details-text my-4">
                      <strong>
                        Alan Boswell Insurance Brokers Ltd - Norwich
                      </strong>
                    </p>
                    <p className="page-details-text">
                      Account Name: Alan Boswell Insurance Brokers Limited
                      Insurer Trust Account
                      <br />
                      Account Number: 60151971
                      <br />
                      Sort Code: 20-62-61
                    </p>
                  </div>
                </Col>
              </Row>

              <button
                type="button"
                className="btn btn-outline-abg rounded-0 px-5 py-3"
                onClick={(event: any) => {
                  this.setState({ payByBacs: false });
                }}
              >
                Back
              </button>
            </div>
          )}

        {/*Pay by BACS - S-Tech Version*/}
        {this.state.payByBacs && config.brand && config.brand == "stech" && (
          <div>
            <Row>
              <Col>
                <h2 className="section_title mb-4">Pay by BACS</h2>

                <p className="page-details-text my-4">
                  Please use the following bank details to make your payment.
                  Enter your reference&nbsp;
                  {this.state.currentRef.substring(2, 8)}&nbsp;on your payment
                  to help us allocate it.
                </p>

                <div className="my-5">
                  <p className="page-details-text my-4">
                    <strong>
                      Alan Boswell Insurance Brokers Ltd - Norwich
                    </strong>
                  </p>
                  <p className="page-details-text">
                    Account Name: Alan Boswell Insurance Brokers Limited Insurer
                    Trust Account
                    <br />
                    Account Number: 60151971
                    <br />
                    Sort Code: 20-62-61
                  </p>
                </div>
              </Col>
            </Row>

            <button
              type="button"
              className="btn btn-outline-abg rounded-0 px-5 py-3"
              onClick={(event: any) => {
                this.setState({ payByBacs: false });
              }}
            >
              Back
            </button>
          </div>
        )}

        {this.state.uppDetails ? (
          <form
            hidden={true}
            action={this.state.uppDetails.url}
            method={"post"}
            ref={this.formRef}
          >
            <input
              type={"hidden"}
              name={"access_token"}
              value={this.state.uppDetails.token}
            />
          </form>
        ) : null}
      </div>
    );
  }
}

export default connect(
  (state: ApplicationState) => ({ customer: state.customer }),
  actionCreators,
)(CustomerLookup);
